import { PushToTalkToggle } from "./PushToTalkToggle";
import { HistoryToggle } from "./HistoryToggle";
import { MessagesToggle } from "./MessagesToggle";
import { KnowledgeBaseToggle } from "./KnowledgeBaseToggle";
import { SchadenKIToggle } from "./SchadenKIToggle";
import { MaintenanceToggle } from "./MaintenanceToggle";
import { featureFlags } from "@/lib/featureFlags";

export function InteractiveSessionSettings() {
  return (
    <div className="space-y-4">
      {featureFlags.maintenance && <MaintenanceToggle />}
      <PushToTalkToggle />
      <HistoryToggle />
      <MessagesToggle />
      <KnowledgeBaseToggle />
      {featureFlags.schadenKI && <SchadenKIToggle />}
    </div>
  );
}